import { Camera, Disc, Home, Magnet, PersonStanding } from "lucide-react";
import React from "react";

/**
 * Safe / minimal silhouette hero for an education/coaching institute.
 * Uses the user's uploaded file as the raw image source but applies
 * strong blur/overlay/color-wash to produce a silhouette/minimal effect.
 *
 * Image path (local): /mnt/data/Screenshot 2025-11-15 215547.png
 */
const HERO_IMG = "/mnt/data/Screenshot 2025-11-15 215547.png";

export default function HeroCard25() {
  return (
    <>
  
      <section className="eh-hero">
        {/* decorative gradient background and subtle text-hc25ure */}
        <div className="eh-bg" style={{ backgroundImage: `url(${HERO_IMG})` }} />

        {/* Left content */}
        <div className="eh-left">
          <div className="eh-accent-row">
            <span className="eh-line" />
            <span className="eh-tag">Learn New Things Daily</span>
          </div>

          <h1 className="eh-title">
            VW Education Perfect <br />
            Place For Your Education <br />
            <span>Next Level</span>
          </h1>

          <p className="eh-desc">
            Lorem ipsum is simply dummy text-hc25 of the printing and typesetting industry.
            Lorem Ipsum has been the industry's standard dummy text-hc25 ever since.
          </p>

          <div className="eh-ctas">
            <button className="btn btn-primary">View Course</button>
            <button className="btn btn-alt">Explore More</button>
          </div>
        </div>

        {/* Right "card-hc25s" column (minimal silhouettes style) */}
        <aside className="eh-right">
          <div className="eh-follow">
            <span>Follow Us</span>
            <div className="icon-hc25s">
              <button className="i">f</button>
              <button className="i">x</button>
              <button className="i">ig</button>
              <button className="i">yt</button>
            </div>
          </div>

          <div className="eh-card-hc25s">
            <div className="card-hc25 card-hc25-mentor">
              <div className="icon-hc25 Color2-hc-25"><Magnet color={"#222"} size={20}/></div>
              <div className="text-hc25">
                <strong>Professional Mentor</strong>
                <small>Trusted teaching & guidance</small>
              </div>
            </div>

            <div className="card-hc25 card-hc25-review">
              <div className="avatar-box">
                <div className="mini-av" />
                <div className="mini-av" />
                <div className="mini-av" />
              </div>
              <div className="text-hc25">  <div className="icon-hc25 Color1-hc-25"><Home  color={"#ffffff"}  size={20}/></div>
             
                <strong>2k review</strong>
                <small>Happy learners</small>
              </div>
            </div>

            <div className="card-hc25 card-hc25-mode">
              <div className="icon-hc25 Color2-hc-25"><Disc  color={"#222"}  size={20}/></div>
              <div className="text-hc25">
                <strong>Offline & Online</strong>
                <small>Flexible learning</small>
              </div>
            </div>
          </div>
        </aside>

        {/* small floating shapes to reinforce silhouette theme */}
        <div className="eh-shapes">
          <span className="dot-cm-hc25" />
          <span className="dot-cm-hc25" />
          <span className="square" />
        </div>
      <style>{`
/* ---------- Layout ---------- */
.text-hc25{display: flex;
  flex-direction: column;
  gap: 10px;
  }
.eh-hero {
  position: relative;
  min-height: 78vh;
  display: flex;
  align-items: center;
  gap: 28px;
  padding: 72px 6%;
  overflow: hidden;
  font-family: Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
  background: linear-gradient(180deg, #fff6f0 0%, #fff9f4 100%);
  color: #0b1220;
}

/* BACKGROUND image used but heavily masked to create SILHOUETTE effect */
.eh-bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center right;
  filter: blur(10px) grayscale(1) saturate(0.4) contrast(0.8);
  opacity: 0.95;
  transform: scale(1.03);
  z-index: 0;
}

/* soft color wash on top of the photo to produce uniform silhouette look */
.eh-hero::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, rgba(255,240,234,0.85) 0%, rgba(255,246,238,0.95) 55%, rgba(255,250,248,1) 100%);
  z-index: 1;
  pointer-events: none;
}

/* Left content (text-hc25) */
.eh-left {
  position: relative;
  z-index: 2;
  flex: 1 1 55%;
  max-width: 700px;
  padding-right: 20px;
}

.eh-accent-row {
  display:flex;
  gap: 14px;
  align-items: center;
  margin-bottom: 14px;
}
.eh-line {
  width: 56px;
  height: 4px;
  background: linear-gradient(90deg, #ff7a00, #ff9a3d);
  border-radius: 3px;
  display:inline-block;
}
.eh-tag {
  color: #ff7a00;
  font-weight: 700;
  font-size: 0.95rem;
  font-style: italic;
}
.Color1-hc-25{background:#ff7a00 !important;}
.Color2-hc-25{background:#ffffff !important;box-shadow: 0 12px 30px rgba(255,122,0,0.12);}
/* Title */
.eh-title {
  font-size: 2.9rem;
  line-height: 1.04;
  margin: 6px 0 18px;
  font-weight: 800;
  color: #111827;
}
.eh-title span {
  color: #ff7a00;
}

/* Desc */
.eh-desc {
  max-width: 60ch;
  color: #374151;
  margin-bottom: 22px;
}

/* CTA */
.eh-ctas { display:flex; gap: 14px; align-items:center; }
.btn {
  padding: 12px 20px;
  border-radius: 10px;
  font-weight: 700;
  border: none;
  cursor: pointer;
}
.btn-primary {
  background: linear-gradient(90deg,#ff7a00,#ff9a3d);
  color: white;
  box-shadow: 0 12px 30px rgba(255,122,0,0.12);
}
.btn-alt {
  background: linear-gradient(90deg,#5b4cff,#7a63ff);
  color: white;
  box-shadow: 0 12px 30px rgba(87,75,255,0.12);
}

/* Right area */
.eh-right {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: 18px;
  align-items: flex-end;
  width: 36%;
  min-width: 300px;
}

/* Follow row */
.eh-follow {
  background: #fff;
  padding: 8px 10px;
  border-radius: 10px;
  display:flex;
  align-items:center;
  gap: 10px;
  box-shadow: 0 8px 26px rgba(13,36,75,0.06);
  font-weight: 600;
}
.eh-follow .icon-hc25s { display:flex; gap:8px; }
.eh-follow .i {
  background: #111827;
  color: #fff;
  border: none;
  width: 34px;
  height: 34px;
  border-radius: 6px;
  display:grid;
  place-items:center;
  font-weight:700;
}

/* Cards stack */
.eh-card-hc25s { display:flex; flex-direction: column; gap: 18px; margin-top: 10px; width: 100%; align-items: flex-end; }

/* general card-hc25 */
.card-hc25 {
  width: 320px;position:relative;
  background: linear-gradient(180deg, #fff 0%, #fffefc 100%);
  border-radius: 18px;
  padding: 18px;margin-top:20px;
  box-shadow: 0 12px 34px rgba(10,20,40,0.06);
  display:flex;
  gap: 12px;
  align-items: center;
}

/* orange mentor card-hc25 block to echo original screenshot */
.card-hc25-mentor {
  background: linear-gradient(180deg,#ff7a00 0%, #ff8f35 100%);
  color: #fff;
}

/* review card-hc25 uses white with inset images */
.card-hc25-review {
  display:flex;
  justify-content: space-between;
  align-items: center;
}

/* small avatars inside review card-hc25 (decorative silhouettes) */
.avatar-box {
  display:flex; gap:6px; align-items:center;
}
.mini-av {
  width:34px; height:34px; background: linear-gradient(180deg,#f0f0f0,#e8e8e8);
  border-radius: 50%;
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.6);
}

/* card-hc25 icon-hc25 */
.card-hc25 .icon-hc25 { z-index:999;
  width: 46px;position:absolute;top:-30px;
  height: 46px;
  display:grid;
  place-items:center;
  background: rgba(255,255,255,1);
  border-radius: 10px;
  font-size: 1.2rem;
}

/* minimal floating shapes */
.eh-shapes .dot-cm-hc25, .eh-shapes .square {
  position:absolute;
  z-index: 1;
}
.eh-shapes .dot-cm-hc25 {
  width: 10px; height:10px; background: rgba(0,0,0,0.06); border-radius:50%;
  left: 12%; top: 12%;
}
.eh-shapes .square {
  width: 20px; height:20px; background: rgba(0,0,0,0.03);
  right: 18%; bottom: 8%;
}

/* subtle entrance animation (CSS-only) */
@keyframes lift-hc25 {
  from { opacity: 0; transform: translateY(58px); }
  to { opacity: 1; transform: translateY(20); }
}
.eh-left, .eh-right { animation: lift-hc25 900ms ease both; }

/* RESPONSIVE */
@media (max-width: 1000px) {
  .eh-hero { flex-direction: column; padding: 42px 5%; min-height: auto; }
  .eh-left, .eh-right { width: 100%; max-width: 100%; }
  .card-hc25 { width: 92%; }
  .eh-right { align-items: center; margin-top: 18px; }
  .eh-bg { background-position: center; filter: blur(12px) grayscale(1) saturate(0.2) contrast(0.8); }
}
      `}</style>
      </section>
    </>
  );
}
